export const FORECAST_CATEGORIES = ['Omitted', 'Pipeline', 'Best Case', 'Commit', 'Closed'];
export const DEFAULT_COLOR = '#d9d9d9';

export const EMPTY_STAGE_FORM = {
  name: '',
  default_probability: '',
  sequence_order: '',
  forecast_category: 'Pipeline',
  is_closed: false,
  is_won: false,
  color: DEFAULT_COLOR,
};

export const toStageOption = (value, label, sortOrder = 0) => ({
  value: String(value || ''),
  label: String(label || value || ''),
  sort_order: Number(sortOrder) || 0,
});

export const extractStageOptions = (stageField) => {
  if (!stageField) return [];

  const source = Array.isArray(stageField.picklist_values_data)
    ? stageField.picklist_values_data
    : Array.isArray(stageField.picklist_values_json)
      ? stageField.picklist_values_json
      : [];

  return source
    .filter((pv) => pv && pv.is_active !== false)
    .map((pv) =>
      toStageOption(
        pv.key || pv.value_key || pv.value,
        pv.label || pv.value_label || pv.value,
        pv.sort_order
      )
    )
    .filter((opt) => opt.value)
    .sort((a, b) => a.sort_order - b.sort_order || a.label.localeCompare(b.label));
};

export const normalizeHexColor = (value) => {
  const raw = String(value || DEFAULT_COLOR).trim();
  return /^#[0-9A-Fa-f]{6}$/.test(raw) ? raw.toLowerCase() : DEFAULT_COLOR;
};

export const formFromStage = (stage) => {
  if (!stage) return { ...EMPTY_STAGE_FORM };
  return {
    name: stage.name || '',
    default_probability: stage.default_probability ?? '',
    sequence_order: stage.sequence_order ?? '',
    forecast_category: stage.forecast_category || 'Pipeline',
    is_closed: Boolean(stage.is_closed),
    is_won: Boolean(stage.is_won),
    color: normalizeHexColor(stage.color),
  };
};
